import styled from "styled-components";

export const FooterContainer = styled.footer`
  background: #dcdcdc;
  padding: 2rem 2rem;
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center; /* Change this to center the content horizontally */
  }
`;

export const Logo = styled.img`
  width: 95px;
  height: auto;
  margin-bottom: 1rem;
  padding-left: 0.2rem;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const LocationInfo = styled.div`
  text-align: center; /* Center the content in desktop mode */
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    text-align: left; /* Align the content to the left in desktop mode */
    margin-bottom: 0;
    margin-left: 2rem; /* Add some left margin for spacing */
  }

  p {
    color: #595959;
    font-family: Poppins;
    font-size: 0.8rem;
    margin: 0.2rem;
  }
`;

export const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
  }
`;

export const FooterLink = styled.a`
  color: #595959;
  font-family: Poppins;
  font-size: 0.8rem;
  text-decoration: none;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    margin: 0.5rem 0;
  }

  img {
    width: 30px;
    height: 30px;
    margin-right: 10px; /* Add a 10px margin between the images */
  }
`;

export const FooterMessage = styled.span`
  color: #595959;
  font-family: Poppins;
  font-size: 0.8rem;
  padding-top: 7rem;

  @media (min-width: 768px) {
    text-align: right; /* Align the content to the right in desktop mode */
    margin-right: 2rem; /* Add right margin for spacing */
  }

  div {
    margin-right: 15px;
    display: flex;
    align-items: center;
  }

  img {
    margin-right: 1rem; /* Add right margin for spacing */
  }
`;
